module.exports = __webpack_public_path__ + "static/media/SHREYA C H.4c83df6c.jpg";